import HeaderAdmin from "./ManageUser/HeaderAdmin";
import MenuAdmin from "./Menu";

const HomeAdmin = () => {
  return (
    <div className="admin-layout-root">
      <HeaderAdmin />
      <MenuAdmin />
    </div>
  );
};

export default HomeAdmin;
